export default __webpack_public_path__ + "static/media/slide-Vimepay.2c7417d0.png";